var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"default-button focus:outline-none focus:shadow-outline whitespace-no-wrap",class:_vm.classObject,attrs:{"disabled":_vm.loading || _vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }